import React from 'react'
import { Card, Divider, Flex, Tag } from 'antd'
import { t } from 'i18next'
import dayjs from 'dayjs'
import EventTag from '../Admin/TagsPage/EventTag'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export const PHONE_NUMBER = '04 48 24 01 28'
export const PHONE_HREF = 'tel:+33448240128'

export function onlyUnique (value, index, array) {
  return array.indexOf(value) === index
}

export function screenSize () {
  const screens = useBreakpoint()
  if (screens.xs) {
    return 'Mobile'
  } else if (screens.sm && !screens.lg) {
    return 'Tablet'
  } else {
    return 'Computer'
  }
}

export const JOBS = ['cleaning', 'maintenance', 'municipacility', 'hospital', 'territory_responsable', 'emergency']

export function stripHtml (html) {
  const tmp = document.createElement('DIV')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

export function slotTitle (slot) {
  if (slot.type === 'CleaningSlot') {
    return `[Nettoyage] ${slot.name}`
  } else if (slot.type === 'MaintenanceSlot') {
    return `[Maintenace] ${slot.name}`
  } else if (slot.type === 'PatientSlot') {
    return `${slot.name}`
  }
}

function displayedTagsHierarchy (displayedTags, displayTag = false) {
  const hierarchy = {}
  displayedTags.forEach((tag) => {
    if (hierarchy[tag.family.business_area.id] === undefined) {
      hierarchy[tag.family.business_area.id] = { businessArea: tag.family.business_area, families: [], tags: [] }
    }
    if (!hierarchy[tag.family.business_area.id].families.map((e) => e.id).includes(tag.family.id)) {
      hierarchy[tag.family.business_area.id].families.push(tag.family)
    }
    if (displayTag) {
      hierarchy[tag.family.business_area.id].tags.push(tag)
    }
  })
  return hierarchy
}

function hierarchyToHtmlTag (hierarchy) {
  const hierarchyFormat = []
  for (const key in hierarchy) {
    const businessArea = hierarchy[key].businessArea
    const families = hierarchy[key].families
    const tags = hierarchy[key].tags
    let hierarchyTags = families.map((family) => (<EventTag key={family.id} tag={family} type='family' />))
    if (tags.length !== 0) {
      hierarchyTags = hierarchyTags.concat(tags.map((tag) => (<EventTag key={tag.id} tag={tag} type='tag' />))).flat()
    }
    hierarchyTags.unshift(<EventTag key={businessArea.id} tag={businessArea} type='businessArea' />)
    hierarchyFormat.push(hierarchyTags)
  }
  return hierarchyFormat
}

export function displayHierarchy (displayedTags, displayTag = false) {
  if (displayedTags?.length === 0) {
    return t('Admin.Event.noTags')
  } else {
    return hierarchyToHtmlTag(displayedTagsHierarchy(displayedTags, displayTag)).map((tags, index) => (
      <div key={`div-${index}`}>
        {tags}
      </div>
    ))
  }
}

export function displayBoxEmptyFields (fields) {
  return fields.map((field) => (<div key={field}>- {t(`Admin.BoxList.table.${field}`)}</div>))
}

export function Logs ({ entries, title }) {
  const entryRender = (entry) => (
    <Flex align='center' gap='middle' key={entry.id}>
      <Tag color={entry.color} variant='solid'>
        <span style={{ fontFamily: 'sans-serif', fontWeight: 'bold' }}>
          {dayjs(entry.created_at).format('HH:mm:ss')}
        </span>
      </Tag>
      {entry.message}
    </Flex>
  )

  const header = <Flex align='center' gap='middle' vertical style={{ padding: '1em 0' }}>
    <div style={{ fontSize: '22px' }}>{t('Admin.Common.Logs.header')}</div>
    {title}
  </Flex>
  const elements = entries.flatMap((entry, index) => [<Divider key={`divider-${index}`} />, entryRender(entry)]).slice(1)

  return (
    <Card title={header} style={{ maxHeight: '45em', overflowY: 'scroll' }} >
      <Flex vertical>
        {elements}
      </Flex>
    </Card>
  )
}
